export default {"src":"/_next/static/media/pencil_bold.82186d03.svg","height":24,"width":24};